import { Form } from 'react-bootstrap';

import { ICandidateField, IFields } from './CandidateFillModal';

export interface MapFormProps {
  field: IFields;
  candidate: ICandidateField;
  update: (
    e: any,
    id: number,
    element: ICandidateField,
    setter: (value: React.SetStateAction<ICandidateField>) => void,
    list: ICandidateField[],
    setterList: (value: React.SetStateAction<ICandidateField[]>) => void
  ) => void;
  id: number;
  setter: (value: React.SetStateAction<ICandidateField>) => void;
  list: ICandidateField[];
  setterList: (value: React.SetStateAction<ICandidateField[]>) => void;
  type: string;
}

const MapForm = (props: MapFormProps) => {
  return (
    <>
      {Object.keys(props.field).map((key: any, i) => {
        if (props.field[key as keyof IFields].length === 0) return <></>;
        else if (props.field[key as keyof IFields][0] === 'void') return <div key={props.type + key + i} />;
        else if (props.field[key as keyof IFields][0] === 'select') {
          return (
            <Form.Group className="mt-2" key={props.type + key} controlId={props.type + key}>
              <Form.Label className=" add-prop-Form ms-2">{props.field[key as keyof IFields][1]}</Form.Label>
              <Form.Select
                value={props.candidate[key as keyof ICandidateField]}
                className="mb-2"
                onChange={(e) => props.update(e, props.id, props.candidate, props.setter, props.list, props.setterList)}
                required
              >
                {props.field[key as keyof IFields][2].map((value: any, i: string) => {
                  return props.field[key as keyof IFields][3][i] === '<hr/>' ? (
                    <hr key={props.type + key + 'hr-' + i} />
                  ) : (
                    <option key={props.type + key + '-' + i} value={value}>
                      {/* selected={value === props.candidate[key as keyof ICandidateField]} */}
                      {props.field[key as keyof IFields][3][i]}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          );
        } else {
          return (
            <Form.Group className="mt-2" key={props.type + key} controlId={props.type + key}>
              <Form.Label className=" add-prop-Form ms-2">{props.field[key as keyof IFields][1]}</Form.Label>
              <Form.Control
                className=" add-prop-Form"
                type={props.field[key as keyof IFields][0]}
                name={key}
                value={props.candidate[key as keyof ICandidateField]}
                onChange={(e) => props.update(e, props.id, props.candidate, props.setter, props.list, props.setterList)}
                required
              />
            </Form.Group>
          );
        }
      })}
    </>
  );
};

export default MapForm;
